import type {
  SubmitErrorResponse,
  SubmitResponse,
  SubmitSuccessResponse,
  ValidateResponse,
  ValidateSuccessResponse,
  ValidationFailedError,
  ValidationIssue,
} from "./types.js";

type ErrorCapableResponse = SubmitResponse | ValidateResponse;

export function isSubmitSuccess(response: SubmitResponse): response is SubmitSuccessResponse {
  return response.ok === true;
}

export function isValidateSuccess(response: ValidateResponse): response is ValidateSuccessResponse {
  return response.ok === true;
}

export function isSubmitError(response: ErrorCapableResponse): response is SubmitErrorResponse {
  return response.ok === false;
}

export function isValidationError(
  response: ErrorCapableResponse,
): response is SubmitErrorResponse & { error: ValidationFailedError } {
  return response.ok === false && response.error.code === "VALIDATION_FAILED";
}

export function getFieldErrors(response: ErrorCapableResponse, path: string): ValidationIssue[] {
  if (!isValidationError(response)) {
    return [];
  }

  return response.error.fields[path] ?? [];
}

export function getFirstFieldError(
  response: ErrorCapableResponse,
  path: string,
): ValidationIssue | null {
  return getFieldErrors(response, path)[0] ?? null;
}

export function getFormErrors(response: ErrorCapableResponse): ValidationIssue[] {
  return getFieldErrors(response, "_form");
}
